// removed by extract-text-webpack-plugin
module.exports = {"Overlay":"_8iIiL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Overlay/Overlay.scss
// module id = 436
// module chunks = 0